<template>
	<div class="pages-setting">
		<van-nav-bar class="custom-nav-bar" :title="$t('common.edit')">
			<template #left>
				<div style="width: 86px; height: 32px; margin-left: 15px;" @click="back()">
					<div class="nav-bar__back">
						<span class="tn-icon-left-arrow"></span>
					</div>
				</div>
			</template>
		</van-nav-bar>

		<div class="page-content">
			<div class="form-card">
				<div class="form-header">
					<div class="form-title">
						{{ $t('common.information') }}
					</div>
				</div>

				<div class="form-item">
					<div class="form-item__label">
						<span class="required">*</span>
						<span>{{ $t('common.username') }}</span>
					</div>
					<div class="form-item__input">
						<div class="input-field">
							<input
								type="text"
								:value="userInfo.username || ''"
								:placeholder="$t('common.username')"
								readonly
							/>
						</div>
					</div>
				</div>
				<div class="form-item">
					<div class="form-item__label">
						<span class="required">*</span>
						<span>{{ $t('setting.pay_password') }}</span>
					</div>
					<div class="form-item__input">
						<div class="input-field">
							<input
								v-model="o_new_password"
								type="password"
								:placeholder="$t('setting.pay_password')"
							/>
						</div>
					</div>
				</div>
			</div>

			<div class="hint-card">
				<div class="hint-header">
					<div class="hint-title">
						{{ $t('common.notice') }}
					</div>
				</div>
				<div class="hint-content">
					<div class="hint-text">
						{{ $t('setting.password_rule_tip') }}
					</div>
				</div>
			</div>

			<div class="submit-section">
				<div class="btn" @click="save()">{{ $t('common.edit') }}</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				o_new_password: "",
				userInfo: {}
			};
		},
		methods: {
			back() {
				return window.history.back();
			},
			save() {
				if (!this.o_new_password) {
					this.$toast.fail(this.$t("setting.prefect"));
					return false;
				}
				const data = {
					paypassword: this.o_new_password // 新密码
				};

				this.$http({
					method: 'post',
					data: data,
					url: 'user_set_paypw'
				}).then(res => {
					if (res.code === 200) {
						this.$toast(res.msg);
						setTimeout(() => {
							localStorage.clear();
							this.$router.push("Login");
						}, 500);
					} else if (res.code === 401) {
						this.$toast(res.msg);
					}
				});
			},
			getUserInfo() {
				this.$http({
					method: 'get',
					url: 'user_info'
				}).then(res => {
					if (res.code === 200) {
						this.userInfo = res.data;
					} else if (res.code === 401) {
						this.$toast(res.msg);
					}
				})
			}
		},
		created() {
			if (!localStorage.getItem('token')) {
				this.$router.push({
					path: '/Login'
				})
			} else {
				this.getUserInfo();
			}
		}
	};
</script>

<style lang='less' scoped>
	/* 页面背景 */
	.pages-setting {
		width: 100%;
		height: 100vh;
		background-color: #f5f5f5;
		padding-bottom: 0;
		padding-bottom: constant(safe-area-inset-bottom);
		padding-bottom: env(safe-area-inset-bottom);
	}

	/* 页面内容 */
	.page-content {
		padding: 20px 10px;
	}

	.custom-nav-bar {
		height: 45px;
		position: fixed;
		z-index: 999;
		display: block;
		position: relative;
		line-height: normal;
	}

	::v-deep .van-nav-bar__content {
		display: flex;
		align-items: center;
		justify-content: space-between;
		min-height: 0;
		height: 45px;
		padding-top: 0px;
		background-color: rgb(255, 255, 255);
		z-index: 29090;
		box-shadow: 0px 0px 41px 0px rgba(0, 0, 0, .05);
		position: fixed;
		width: 100%;
		top: 0;
	}

	::v-deep .van-nav-bar__left {
		padding: 0;
	}

	::v-deep .van-nav-bar__title {
		color: #000 !important;
		font-size: 18px;
		font-weight: 700;
		top: 0px;
		height: 45px;
		line-height: 45px;
		width: calc(100% - 202px);
		position: absolute;
		text-align: center;
		left: 0;
		right: 0;
		bottom: 0;
		cursor: none;
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
	}

	.nav-bar__back {
		width: 31px;
		height: 31px;
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;
		box-sizing: border-box;
		background-color: rgba(0, 0, 0, .05);
		border-radius: 50%;
		color: #333;
		font-size: 14px;
	}

	/* 表单卡片 */
	.form-card {
		background: #fff;
		border-radius: 8px;
		margin-bottom: 12px;
		padding: 15px;
		box-shadow: 0 1px 6px rgba(0, 0, 0, .08)
	}

	.form-card .form-header {
		margin-bottom: 12px
	}

	.form-card .form-header .form-title {
		font-size: 14px;
		font-weight: 600;
		color: #333
	}

	.form-card .form-item {
		display: flex;
		align-items: center;
		margin-bottom: 12px
	}

	.form-card .form-item:last-child {
		margin-bottom: 0
	}

	.form-card .form-item__label {
		width: 83px;
		font-size: 14px;
		color: #333;
		position: relative
	}

	.form-card .form-item__input {
		flex: 1
	}

	/* 必填标识 */
	.required {
		color: #ff3b30;
		font-size: 14px;
		margin-right: 4px
	}

	/* 输入框 */
	.input-field {
		width: 100%;
		font-size: 14px;
		color: #333;
		padding: 12px 0;
		border-bottom: 0.5px solid #f0f0f0;
		background: #fafafa;
		border-radius: 4px;
		padding-left: 8px;
		padding-right: 8px;
		min-height: 41px;
		box-sizing: border-box
	}

	.input-field:focus {
		border-bottom-color: #1f77d5;
		background: #fff;
		box-shadow: 0 0 0 1px rgba(31, 119, 213, .1)
	}

	.input-field input {
		display: -webkit-box;
		display: -webkit-flex;
		display: flex;
		position: relative;
		width: 100%;
		height: 100%;
		-webkit-box-orient: vertical;
		-webkit-box-direction: normal;
		-webkit-flex-direction: column;
		flex-direction: column;
		-webkit-box-pack: center;
		-webkit-justify-content: center;
		justify-content: center;
		outline: none;
		border: none;
		padding: 0;
		margin: 0;
		text-decoration: inherit;
		position: relative;
		display: block;
		height: 100%;
		background: none;
		color: inherit;
		opacity: 1;
		font: inherit;
		line-height: inherit;
		letter-spacing: inherit;
		text-align: inherit;
		text-indent: inherit;
		text-transform: inherit;
		text-shadow: inherit;
	}

	.input-field input::placeholder {
		color: #a9a9a9;
		font-size: 14px;
	}

	/* 提示信息卡片 */
	.hint-card {
		background: #f8f9fa;
		border-radius: 8px;
		padding: 12px;
		margin-bottom: 16px;
		border-left: 2px solid #1f77d5
	}

	.hint-card .hint-header {
		margin-bottom: 6px
	}

	.hint-card .hint-header .hint-title {
		font-size: 12px;
		font-weight: 600;
		color: #333
	}

	.hint-card .hint-content .hint-text {
		font-size: 11px;
		color: #666;
		line-height: 1.5
	}

	/* 提交按钮 */
	.submit-section {
		margin-top: 10px
	}

	.btn {
		color: #fff !important;
		padding: 15px 0px;
		font-size: 14px;
		height: 33px;
		width: 100%;
		background-color: rgb(31, 119, 213);
		box-shadow: rgba(31, 119, 213, 0.063) 3px 3px 4px;
		position: relative;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		box-sizing: border-box;
		line-height: 1;
		text-align: center;
		text-decoration: none;
		overflow: visible;
		-webkit-transform: translate(0px, 0px);
		transform: translate(0px, 0px);
		border-radius: 6px;
		margin: 0;
	}

	.btn::before {
		content: " ";
		display: block;
		background: inherit;
		-webkit-filter: blur(5px);
		filter: blur(5px);
		position: absolute;
		width: 100%;
		height: 100%;
		top: 5px;
		left: 5px;
		z-index: -1;
		opacity: .4;
		-webkit-transform-origin: 0 0;
		transform-origin: 0 0;
		border-radius: inherit;
		-webkit-transform: scale(1);
		transform: scale(1);
	}

	.btn::after {
		content: " ";
		width: 200%;
		height: 200%;
		position: absolute;
		top: 0;
		left: 0;
		border: 1px solid rgba(0, 0, 0, .2);
		-webkit-transform: scale(.5);
		transform: scale(.5);
		-webkit-transform-origin: 0 0;
		transform-origin: 0 0;
		box-sizing: border-box;
		border-radius: 10px;
		border: none;
	}

	/* 导航栏返回按钮 */
	.tn-custom-nav-bar__back {
		width: 31px;
		height: 31px;
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;
		box-sizing: border-box;
		background-color: rgba(0, 0, 0, .05);
		border-radius: 50%;
		color: #333;
		font-size: 14px
	}

	.tn-custom-nav-bar__back .icon {
		display: block
	}
</style>
